class GameIdentity {
  public constructor(public readonly name: string, public readonly clubName: string, public readonly clubId: number) {
  }

  public get nameForConfiguration(): string {
    return this.name.replace(/\s/g, '').toLowerCase();
  }
}

export { GameIdentity };



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/components/game/_domain/models/game-identity.ts